import { createFileRoute } from "@tanstack/react-router";
import { smsOptInApiRoute } from "@/features/viewer-profile";

export const Route = createFileRoute("/api/sms-opt-in")({
    ...smsOptInApiRoute,
});
